

































import { Component, Model, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import _ from "lodash";

@Component({
    components: {}
})
export default class BooleanScoringDefinitionRuleCreator extends Vue {
    @Model()
    scoringRules!: any[];

    @Prop()
    scoringKeys!: any[];

    @Prop()
    values!: boolean[];

    @Prop()
    tab: number

    private inverted = false;

    mounted() {
        if (this.scoringRules && this.scoringRules.length > 0) {
            //Should only ever be one
            let scoringRule = this.scoringRules[0]
            this.inverted = scoringRule.inverted;
        } else {
            this.initializeScoringRules()
        }
    }

    get valueCounts() {
        return _.countBy(this.values)
    }

    get chartLabels() {
        return Object.keys(this.valueCounts)
    }

    get chartSeriesData() {
        return [{name: "Count", data: Object.values(this.valueCounts)}]

    }

    private initializeScoringRules() {
         this.scoringKeys.forEach((sk, index) => {
            let scoringRule = {
                inverted: this.inverted,
                scoringKey: sk,
            }
            this.scoringRules.splice(this.scoringRules.length, 0, scoringRule)
        })
    }

    @Watch('tab')
    private onChangeTab(){
        if(this.tab === 1 && this.scoringRules.length === 0){
            this.initializeScoringRules()
        }
    }

    @Watch('inverted')
    private onChangeInverted(){
        this.scoringRules.splice(0,this.scoringRules.length)
        this.initializeScoringRules()
        
    }
    

    get chartOptions() {
        return {
            chart: {
                type: 'bar',
                height: '200',
                toolbar: {
                    show: false
                }
            },
            plotOptions: {
                bar: {
                    horizontal: true,
                    distributed: false,
                    barHeight: '20%'
                }
            },
            dataLabels: {
                enabled: false
            },
            xaxis: {
                categories: this.chartLabels,
                labels: {
                    formatter: (value: number) => value % 1 === 0 ? value.toFixed(0) : ''
                }
            }
        }
    }
}
